
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.5 27C20.956 27 27 20.956 27 13.5S20.956 0 13.5 0 0 6.044 0 13.5 6.044 27 13.5 27zm.802-14.814a.4.4 0 01-.655-.002l-2.106-3.013A.4.4 0 0011.213 9H9.932a.4.4 0 00-.317.644L12.74 13.7a.4.4 0 01-.001.49l-3.237 4.166a.4.4 0 00.315.645h1.292a.4.4 0 00.325-.166l2.247-3.125a.4.4 0 01.65 0l2.246 3.125A.4.4 0 0016.9 19h1.282a.4.4 0 00.315-.645l-3.237-4.166a.4.4 0 01-.001-.49l3.125-4.055A.4.4 0 0018.068 9h-1.305a.4.4 0 00-.326.169l-2.135 3.017z","fill":"#fff"}})])
          )
        }
      }
    